
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesLaborGrid extends Serenity.EntityGrid<SalesLaborRow, any> {
        protected getColumnsKey() { return 'Sales.SalesLabor'; }
        protected getIdProperty() { return SalesLaborRow.idProperty; }
        protected getInsertPermission() { return SalesLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesLaborRow.localTextPrefix; }
        protected getService() { return SalesLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}